module.exports = __webpack_public_path__ + "static/img/img19.e41b82a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c38/img19.png
// module id = 3Sj0
// module chunks = 0